// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/main/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/main/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IAccountClient {
    getAccountDetails(): Promise<AccountDetails>;
    getAccountNotificationPreferences(): Promise<AccountNotificationPreferenceModel>;
    updateFullName(fullName: string | null | undefined): Promise<void>;
    updateEmail(email: string | null | undefined): Promise<void>;
    cancelEmailUpdate(): Promise<void>;
    verifyEmail(verificationCode: string | null | undefined): Promise<void>;
    updatePhone(phone: string | null | undefined): Promise<void>;
    cancelUpdatePhone(): Promise<void>;
    verifyPhone(verificationCode: string | null | undefined): Promise<void>;
    updateEmailPreferences(news: boolean | undefined): Promise<void>;
    updatePhonePreferences(news: boolean | undefined, reservations: boolean | undefined): Promise<void>;
}

export class AccountClient extends AuthorizedApiBase implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAccountDetails(signal?: AbortSignal): Promise<AccountDetails> {
        let url_ = this.baseUrl + "/mainController/Account/GetAccountDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountDetails(_response);
        });
    }

    protected processGetAccountDetails(response: AxiosResponse): Promise<AccountDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountDetails.fromJS(resultData200);
            return Promise.resolve<AccountDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDetails>(null as any);
    }

    getAccountNotificationPreferences(signal?: AbortSignal): Promise<AccountNotificationPreferenceModel> {
        let url_ = this.baseUrl + "/mainController/Account/GetAccountNotificationPreferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountNotificationPreferences(_response);
        });
    }

    protected processGetAccountNotificationPreferences(response: AxiosResponse): Promise<AccountNotificationPreferenceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountNotificationPreferenceModel.fromJS(resultData200);
            return Promise.resolve<AccountNotificationPreferenceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNotificationPreferenceModel>(null as any);
    }

    updateFullName(fullName: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/UpdateFullName?";
        if (fullName !== undefined && fullName !== null)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFullName(_response);
        });
    }

    protected processUpdateFullName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateEmail(email: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/UpdateEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelEmailUpdate(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/CancelEmailUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelEmailUpdate(_response);
        });
    }

    protected processCancelEmailUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    verifyEmail(verificationCode: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/VerifyEmail?";
        if (verificationCode !== undefined && verificationCode !== null)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePhone(phone: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/UpdatePhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelUpdatePhone(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/CancelUpdatePhone";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelUpdatePhone(_response);
        });
    }

    protected processCancelUpdatePhone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    verifyPhone(verificationCode: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/VerifyPhone?";
        if (verificationCode !== undefined && verificationCode !== null)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyPhone(_response);
        });
    }

    protected processVerifyPhone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateEmailPreferences(news: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/UpdateEmailPreferences?";
        if (news === null)
            throw new Error("The parameter 'news' cannot be null.");
        else if (news !== undefined)
            url_ += "news=" + encodeURIComponent("" + news) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailPreferences(_response);
        });
    }

    protected processUpdateEmailPreferences(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePhonePreferences(news: boolean | undefined, reservations: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Account/UpdatePhonePreferences?";
        if (news === null)
            throw new Error("The parameter 'news' cannot be null.");
        else if (news !== undefined)
            url_ += "news=" + encodeURIComponent("" + news) + "&";
        if (reservations === null)
            throw new Error("The parameter 'reservations' cannot be null.");
        else if (reservations !== undefined)
            url_ += "reservations=" + encodeURIComponent("" + reservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhonePreferences(_response);
        });
    }

    protected processUpdatePhonePreferences(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDataClient {
    getClientData(): Promise<ClientData>;
}

export class DataClient extends AuthorizedApiBase implements IDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getClientData(signal?: AbortSignal): Promise<ClientData> {
        let url_ = this.baseUrl + "/mainController/Data/GetClientData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientData(_response);
        });
    }

    protected processGetClientData(response: AxiosResponse): Promise<ClientData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientData.fromJS(resultData200);
            return Promise.resolve<ClientData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientData>(null as any);
    }
}

export interface IMarketingClient {
    link(code: string): Promise<string>;
}

export class MarketingClient extends AuthorizedApiBase implements IMarketingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    link(code: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Marketing/Link/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLink(_response);
        });
    }

    protected processLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPaymentClient {
    stripeConfig(propertyId: number | undefined): Promise<string>;
    initPayment(bookId: string | null | undefined, model: FinishBookingModel | null): Promise<string>;
    createPaymentIntent(bookId: string | null | undefined): Promise<string>;
}

export class PaymentClient extends AuthorizedApiBase implements IPaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    stripeConfig(propertyId: number | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Payment/StripeConfig?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStripeConfig(_response);
        });
    }

    protected processStripeConfig(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    initPayment(bookId: string | null | undefined, model: FinishBookingModel | null, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Payment/InitPayment?";
        if (bookId !== undefined && bookId !== null)
            url_ += "bookId=" + encodeURIComponent("" + bookId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitPayment(_response);
        });
    }

    protected processInitPayment(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createPaymentIntent(bookId: string | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Payment/CreatePaymentIntent?";
        if (bookId !== undefined && bookId !== null)
            url_ += "bookId=" + encodeURIComponent("" + bookId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentIntent(_response);
        });
    }

    protected processCreatePaymentIntent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPropertyClient {
    getPublicDetails(id: number): Promise<PropertyPublicDetails>;
    getDates(id: number): Promise<CalendarDayPublic[]>;
    startBooking(model: StartBookingModel | null): Promise<string>;
    finishBooking(bookId: string, model: FinishBookingModel | null): Promise<string>;
    cancelBooking(bookId: string): Promise<void>;
    getBookingInfo(bookId: string): Promise<BookingInfo>;
    applyPromoCodeBooking(bookId: string, promoCode: string | null | undefined): Promise<BookingInfo>;
    getRatesByDateRange(id: number, from: number | undefined, to: number | undefined, guests: number | undefined, pets: number | undefined): Promise<BookRatesDetails>;
    getCurrentReservations(): Promise<ReservationAccountShortInfo[]>;
    getReservationYears(): Promise<number[]>;
    getReservationByYear(year: number | undefined): Promise<ReservationAccountShortInfo[]>;
    getReservationAccountDetails(reservationCode: string | null | undefined): Promise<ReservationAccountModel>;
}

export class PropertyClient extends AuthorizedApiBase implements IPropertyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getPublicDetails(id: number, signal?: AbortSignal): Promise<PropertyPublicDetails> {
        let url_ = this.baseUrl + "/mainController/Property/GetPublicDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicDetails(_response);
        });
    }

    protected processGetPublicDetails(response: AxiosResponse): Promise<PropertyPublicDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyPublicDetails.fromJS(resultData200);
            return Promise.resolve<PropertyPublicDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyPublicDetails>(null as any);
    }

    getDates(id: number, signal?: AbortSignal): Promise<CalendarDayPublic[]> {
        let url_ = this.baseUrl + "/mainController/Property/GetDates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDates(_response);
        });
    }

    protected processGetDates(response: AxiosResponse): Promise<CalendarDayPublic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDayPublic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalendarDayPublic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDayPublic[]>(null as any);
    }

    startBooking(model: StartBookingModel | null, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Property/StartBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartBooking(_response);
        });
    }

    protected processStartBooking(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    finishBooking(bookId: string, model: FinishBookingModel | null, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/mainController/Property/FinishBooking/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishBooking(_response);
        });
    }

    protected processFinishBooking(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancelBooking(bookId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/mainController/Property/CancelBooking/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelBooking(_response);
        });
    }

    protected processCancelBooking(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getBookingInfo(bookId: string, signal?: AbortSignal): Promise<BookingInfo> {
        let url_ = this.baseUrl + "/mainController/Property/GetBookingInfo/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBookingInfo(_response);
        });
    }

    protected processGetBookingInfo(response: AxiosResponse): Promise<BookingInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingInfo.fromJS(resultData200);
            return Promise.resolve<BookingInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingInfo>(null as any);
    }

    applyPromoCodeBooking(bookId: string, promoCode: string | null | undefined, signal?: AbortSignal): Promise<BookingInfo> {
        let url_ = this.baseUrl + "/mainController/Property/ApplyPromoCodeBooking/{bookId}?";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyPromoCodeBooking(_response);
        });
    }

    protected processApplyPromoCodeBooking(response: AxiosResponse): Promise<BookingInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingInfo.fromJS(resultData200);
            return Promise.resolve<BookingInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingInfo>(null as any);
    }

    getRatesByDateRange(id: number, from: number | undefined, to: number | undefined, guests: number | undefined, pets: number | undefined, signal?: AbortSignal): Promise<BookRatesDetails> {
        let url_ = this.baseUrl + "/mainController/Property/GetRatesByDateRange/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (guests === null)
            throw new Error("The parameter 'guests' cannot be null.");
        else if (guests !== undefined)
            url_ += "guests=" + encodeURIComponent("" + guests) + "&";
        if (pets === null)
            throw new Error("The parameter 'pets' cannot be null.");
        else if (pets !== undefined)
            url_ += "pets=" + encodeURIComponent("" + pets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRatesByDateRange(_response);
        });
    }

    protected processGetRatesByDateRange(response: AxiosResponse): Promise<BookRatesDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookRatesDetails.fromJS(resultData200);
            return Promise.resolve<BookRatesDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookRatesDetails>(null as any);
    }

    getCurrentReservations(signal?: AbortSignal): Promise<ReservationAccountShortInfo[]> {
        let url_ = this.baseUrl + "/mainController/Property/GetCurrentReservations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentReservations(_response);
        });
    }

    protected processGetCurrentReservations(response: AxiosResponse): Promise<ReservationAccountShortInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationAccountShortInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReservationAccountShortInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationAccountShortInfo[]>(null as any);
    }

    getReservationYears(signal?: AbortSignal): Promise<number[]> {
        let url_ = this.baseUrl + "/mainController/Property/GetReservationYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationYears(_response);
        });
    }

    protected processGetReservationYears(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getReservationByYear(year: number | undefined, signal?: AbortSignal): Promise<ReservationAccountShortInfo[]> {
        let url_ = this.baseUrl + "/mainController/Property/GetReservationByYear?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationByYear(_response);
        });
    }

    protected processGetReservationByYear(response: AxiosResponse): Promise<ReservationAccountShortInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationAccountShortInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReservationAccountShortInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationAccountShortInfo[]>(null as any);
    }

    getReservationAccountDetails(reservationCode: string | null | undefined, signal?: AbortSignal): Promise<ReservationAccountModel> {
        let url_ = this.baseUrl + "/mainController/Property/GetReservationAccountDetails?";
        if (reservationCode !== undefined && reservationCode !== null)
            url_ += "reservationCode=" + encodeURIComponent("" + reservationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationAccountDetails(_response);
        });
    }

    protected processGetReservationAccountDetails(response: AxiosResponse): Promise<ReservationAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReservationAccountModel.fromJS(resultData200);
            return Promise.resolve<ReservationAccountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationAccountModel>(null as any);
    }
}

export interface ISearchClient {
    searchCities(search: string | null | undefined): Promise<SearchCitiesResult[]>;
    getList(param: DataListGetParamsOfPropertySearchParams | null): Promise<DataListResultOfPropertySearchListModel>;
    getSamples(): Promise<PropertySearchListModel[]>;
    getFile(path: string | null | undefined): Promise<FileResponse>;
}

export class SearchClient extends AuthorizedApiBase implements ISearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    searchCities(search: string | null | undefined, signal?: AbortSignal): Promise<SearchCitiesResult[]> {
        let url_ = this.baseUrl + "/mainController/Search/SearchCities?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCities(_response);
        });
    }

    protected processSearchCities(response: AxiosResponse): Promise<SearchCitiesResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchCitiesResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchCitiesResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchCitiesResult[]>(null as any);
    }

    getList(param: DataListGetParamsOfPropertySearchParams | null, signal?: AbortSignal): Promise<DataListResultOfPropertySearchListModel> {
        let url_ = this.baseUrl + "/mainController/Search/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertySearchListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertySearchListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertySearchListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertySearchListModel>(null as any);
    }

    getSamples(signal?: AbortSignal): Promise<PropertySearchListModel[]> {
        let url_ = this.baseUrl + "/mainController/Search/GetSamples";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSamples(_response);
        });
    }

    protected processGetSamples(response: AxiosResponse): Promise<PropertySearchListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertySearchListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertySearchListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertySearchListModel[]>(null as any);
    }

    getFile(path: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/mainController/Search/GetFile?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AccountDetails implements IAccountDetails {
    fullName?: string | undefined;
    email?: string | undefined;
    newEmail?: string | undefined;
    phone?: string | undefined;
    newPhone?: string | undefined;

    constructor(data?: IAccountDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.newEmail = _data["NewEmail"];
            this.phone = _data["Phone"];
            this.newPhone = _data["NewPhone"];
        }
    }

    static fromJS(data: any): AccountDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["NewEmail"] = this.newEmail;
        data["Phone"] = this.phone;
        data["NewPhone"] = this.newPhone;
        return data;
    }

    clone(): AccountDetails {
        const json = this.toJSON();
        let result = new AccountDetails();
        result.init(json);
        return result;
    }
}

export interface IAccountDetails {
    fullName?: string | undefined;
    email?: string | undefined;
    newEmail?: string | undefined;
    phone?: string | undefined;
    newPhone?: string | undefined;
}

export class AccountNotificationPreferenceModel implements IAccountNotificationPreferenceModel {
    phoneReservationNotifications?: boolean;
    phoneNewsNotifications?: boolean;
    emailNewsNotifications?: boolean;

    constructor(data?: IAccountNotificationPreferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneReservationNotifications = _data["PhoneReservationNotifications"];
            this.phoneNewsNotifications = _data["PhoneNewsNotifications"];
            this.emailNewsNotifications = _data["EmailNewsNotifications"];
        }
    }

    static fromJS(data: any): AccountNotificationPreferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNotificationPreferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneReservationNotifications"] = this.phoneReservationNotifications;
        data["PhoneNewsNotifications"] = this.phoneNewsNotifications;
        data["EmailNewsNotifications"] = this.emailNewsNotifications;
        return data;
    }

    clone(): AccountNotificationPreferenceModel {
        const json = this.toJSON();
        let result = new AccountNotificationPreferenceModel();
        result.init(json);
        return result;
    }
}

export interface IAccountNotificationPreferenceModel {
    phoneReservationNotifications?: boolean;
    phoneNewsNotifications?: boolean;
    emailNewsNotifications?: boolean;
}

export class ClientData implements IClientData {
    states?: State[] | undefined;
    amenities?: NamedValueLong[] | undefined;
    propertyTypes?: NamedValueLong[] | undefined;
    propertyRoomTypes?: NamedValueLong[] | undefined;
    propertySleepingArrangementBedTypes?: NamedValueLong[] | undefined;

    constructor(data?: IClientData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(State.fromJS(item));
            }
            if (Array.isArray(_data["Amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["Amenities"])
                    this.amenities!.push(NamedValueLong.fromJS(item));
            }
            if (Array.isArray(_data["PropertyTypes"])) {
                this.propertyTypes = [] as any;
                for (let item of _data["PropertyTypes"])
                    this.propertyTypes!.push(NamedValueLong.fromJS(item));
            }
            if (Array.isArray(_data["PropertyRoomTypes"])) {
                this.propertyRoomTypes = [] as any;
                for (let item of _data["PropertyRoomTypes"])
                    this.propertyRoomTypes!.push(NamedValueLong.fromJS(item));
            }
            if (Array.isArray(_data["PropertySleepingArrangementBedTypes"])) {
                this.propertySleepingArrangementBedTypes = [] as any;
                for (let item of _data["PropertySleepingArrangementBedTypes"])
                    this.propertySleepingArrangementBedTypes!.push(NamedValueLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientData {
        data = typeof data === 'object' ? data : {};
        let result = new ClientData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item.toJSON());
        }
        if (Array.isArray(this.amenities)) {
            data["Amenities"] = [];
            for (let item of this.amenities)
                data["Amenities"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyTypes)) {
            data["PropertyTypes"] = [];
            for (let item of this.propertyTypes)
                data["PropertyTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyRoomTypes)) {
            data["PropertyRoomTypes"] = [];
            for (let item of this.propertyRoomTypes)
                data["PropertyRoomTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.propertySleepingArrangementBedTypes)) {
            data["PropertySleepingArrangementBedTypes"] = [];
            for (let item of this.propertySleepingArrangementBedTypes)
                data["PropertySleepingArrangementBedTypes"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientData {
        const json = this.toJSON();
        let result = new ClientData();
        result.init(json);
        return result;
    }
}

export interface IClientData {
    states?: State[] | undefined;
    amenities?: NamedValueLong[] | undefined;
    propertyTypes?: NamedValueLong[] | undefined;
    propertyRoomTypes?: NamedValueLong[] | undefined;
    propertySleepingArrangementBedTypes?: NamedValueLong[] | undefined;
}

export class State implements IState {
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data;
    }

    clone(): State {
        const json = this.toJSON();
        let result = new State();
        result.init(json);
        return result;
    }
}

export interface IState {
    name?: string | undefined;
    code?: string | undefined;
}

export class NamedValueLong implements INamedValueLong {
    id?: number;
    name?: string | undefined;

    constructor(data?: INamedValueLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValueLong {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValueLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValueLong {
        const json = this.toJSON();
        let result = new NamedValueLong();
        result.init(json);
        return result;
    }
}

export interface INamedValueLong {
    id?: number;
    name?: string | undefined;
}

export class FinishBookingModel implements IFinishBookingModel {
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IFinishBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
        }
    }

    static fromJS(data: any): FinishBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinishBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        return data;
    }

    clone(): FinishBookingModel {
        const json = this.toJSON();
        let result = new FinishBookingModel();
        result.init(json);
        return result;
    }
}

export interface IFinishBookingModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class PropertyPublicDetails implements IPropertyPublicDetails {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    stateDisplay?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    type?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    imageUrl?: string | undefined;
    petMax?: number;
    bathrooms?: number;
    bedrooms?: number;
    sleeps?: number;
    amenities?: string[] | undefined;
    minNights?: number;
    maxNights?: number | undefined;
    images?: PropertyPublicDetailsImage[] | undefined;
    beds?: PropertyPublicDetailsBed[] | undefined;
    rooms?: PropertyPublicDetailsRooms[] | undefined;
    maxGuests?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    policies?: string[] | undefined;
    houseRules?: string | undefined;

    constructor(data?: IPropertyPublicDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.state = _data["State"];
            this.stateDisplay = _data["StateDisplay"];
            this.city = _data["City"];
            this.zipCode = _data["ZipCode"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.type = _data["Type"];
            this.thumbnailImageUrl = _data["ThumbnailImageUrl"];
            this.imageUrl = _data["ImageUrl"];
            this.petMax = _data["PetMax"];
            this.bathrooms = _data["Bathrooms"];
            this.bedrooms = _data["Bedrooms"];
            this.sleeps = _data["Sleeps"];
            if (Array.isArray(_data["Amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["Amenities"])
                    this.amenities!.push(item);
            }
            this.minNights = _data["MinNights"];
            this.maxNights = _data["MaxNights"];
            if (Array.isArray(_data["Images"])) {
                this.images = [] as any;
                for (let item of _data["Images"])
                    this.images!.push(PropertyPublicDetailsImage.fromJS(item));
            }
            if (Array.isArray(_data["Beds"])) {
                this.beds = [] as any;
                for (let item of _data["Beds"])
                    this.beds!.push(PropertyPublicDetailsBed.fromJS(item));
            }
            if (Array.isArray(_data["Rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["Rooms"])
                    this.rooms!.push(PropertyPublicDetailsRooms.fromJS(item));
            }
            this.maxGuests = _data["MaxGuests"];
            this.quietHoursStartTime = _data["QuietHoursStartTime"];
            this.quietHoursEndTime = _data["QuietHoursEndTime"];
            this.quietHoursEnabled = _data["QuietHoursEnabled"];
            this.partiesAllowed = _data["PartiesAllowed"];
            this.smokingAllowed = _data["SmokingAllowed"];
            if (Array.isArray(_data["Policies"])) {
                this.policies = [] as any;
                for (let item of _data["Policies"])
                    this.policies!.push(item);
            }
            this.houseRules = _data["HouseRules"];
        }
    }

    static fromJS(data: any): PropertyPublicDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["State"] = this.state;
        data["StateDisplay"] = this.stateDisplay;
        data["City"] = this.city;
        data["ZipCode"] = this.zipCode;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["Type"] = this.type;
        data["ThumbnailImageUrl"] = this.thumbnailImageUrl;
        data["ImageUrl"] = this.imageUrl;
        data["PetMax"] = this.petMax;
        data["Bathrooms"] = this.bathrooms;
        data["Bedrooms"] = this.bedrooms;
        data["Sleeps"] = this.sleeps;
        if (Array.isArray(this.amenities)) {
            data["Amenities"] = [];
            for (let item of this.amenities)
                data["Amenities"].push(item);
        }
        data["MinNights"] = this.minNights;
        data["MaxNights"] = this.maxNights;
        if (Array.isArray(this.images)) {
            data["Images"] = [];
            for (let item of this.images)
                data["Images"].push(item.toJSON());
        }
        if (Array.isArray(this.beds)) {
            data["Beds"] = [];
            for (let item of this.beds)
                data["Beds"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["Rooms"] = [];
            for (let item of this.rooms)
                data["Rooms"].push(item.toJSON());
        }
        data["MaxGuests"] = this.maxGuests;
        data["QuietHoursStartTime"] = this.quietHoursStartTime;
        data["QuietHoursEndTime"] = this.quietHoursEndTime;
        data["QuietHoursEnabled"] = this.quietHoursEnabled;
        data["PartiesAllowed"] = this.partiesAllowed;
        data["SmokingAllowed"] = this.smokingAllowed;
        if (Array.isArray(this.policies)) {
            data["Policies"] = [];
            for (let item of this.policies)
                data["Policies"].push(item);
        }
        data["HouseRules"] = this.houseRules;
        return data;
    }

    clone(): PropertyPublicDetails {
        const json = this.toJSON();
        let result = new PropertyPublicDetails();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetails {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    stateDisplay?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    type?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    imageUrl?: string | undefined;
    petMax?: number;
    bathrooms?: number;
    bedrooms?: number;
    sleeps?: number;
    amenities?: string[] | undefined;
    minNights?: number;
    maxNights?: number | undefined;
    images?: PropertyPublicDetailsImage[] | undefined;
    beds?: PropertyPublicDetailsBed[] | undefined;
    rooms?: PropertyPublicDetailsRooms[] | undefined;
    maxGuests?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    policies?: string[] | undefined;
    houseRules?: string | undefined;
}

export class PropertyPublicDetailsImage implements IPropertyPublicDetailsImage {
    url?: string | undefined;
    thumbnailUrl?: string | undefined;

    constructor(data?: IPropertyPublicDetailsImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
        }
    }

    static fromJS(data: any): PropertyPublicDetailsImage {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        return data;
    }

    clone(): PropertyPublicDetailsImage {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsImage();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsImage {
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
}

export class PropertyPublicDetailsBed implements IPropertyPublicDetailsBed {
    type?: string | undefined;
    count?: number;

    constructor(data?: IPropertyPublicDetailsBed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PropertyPublicDetailsBed {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsBed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        return data;
    }

    clone(): PropertyPublicDetailsBed {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsBed();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsBed {
    type?: string | undefined;
    count?: number;
}

export class PropertyPublicDetailsRooms implements IPropertyPublicDetailsRooms {
    name?: string | undefined;
    sleeps?: number;
    rooms?: PropertyPublicDetailsBed[] | undefined;

    constructor(data?: IPropertyPublicDetailsRooms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sleeps = _data["sleeps"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(PropertyPublicDetailsBed.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyPublicDetailsRooms {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsRooms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sleeps"] = this.sleeps;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertyPublicDetailsRooms {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsRooms();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsRooms {
    name?: string | undefined;
    sleeps?: number;
    rooms?: PropertyPublicDetailsBed[] | undefined;
}

export class CalendarDayPublic implements ICalendarDayPublic {
    status?: PropertyCalendarItemStatus;
    rate?: number;
    discountRate?: number | undefined;
    date?: number;

    constructor(data?: ICalendarDayPublic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.rate = _data["Rate"];
            this.discountRate = _data["DiscountRate"];
            this.date = _data["Date"];
        }
    }

    static fromJS(data: any): CalendarDayPublic {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayPublic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["Rate"] = this.rate;
        data["DiscountRate"] = this.discountRate;
        data["Date"] = this.date;
        return data;
    }

    clone(): CalendarDayPublic {
        const json = this.toJSON();
        let result = new CalendarDayPublic();
        result.init(json);
        return result;
    }
}

export interface ICalendarDayPublic {
    status?: PropertyCalendarItemStatus;
    rate?: number;
    discountRate?: number | undefined;
    date?: number;
}

/** 1 = Available 2 = Reserved 3 = Unavailable */
export enum PropertyCalendarItemStatus {
    Available = 1,
    Reserved = 2,
    Unavailable = 3,
}

export class StartBookingModel implements IStartBookingModel {
    propertyId?: number;
    from?: number;
    to?: number;
    adults?: number;
    children?: number;
    pets?: number;

    constructor(data?: IStartBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["PropertyId"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.adults = _data["Adults"];
            this.children = _data["Children"];
            this.pets = _data["Pets"];
        }
    }

    static fromJS(data: any): StartBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new StartBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PropertyId"] = this.propertyId;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Adults"] = this.adults;
        data["Children"] = this.children;
        data["Pets"] = this.pets;
        return data;
    }

    clone(): StartBookingModel {
        const json = this.toJSON();
        let result = new StartBookingModel();
        result.init(json);
        return result;
    }
}

export interface IStartBookingModel {
    propertyId?: number;
    from?: number;
    to?: number;
    adults?: number;
    children?: number;
    pets?: number;
}

export class BookingInfo implements IBookingInfo {
    rates?: BookRatesDetails | undefined;
    details?: PropertyPublicDetails | undefined;
    expirationDate?: moment.Moment;
    startBookingModel?: StartBookingModel | undefined;
    reservationCode?: string | undefined;

    constructor(data?: IBookingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rates = _data["Rates"] ? BookRatesDetails.fromJS(_data["Rates"]) : <any>undefined;
            this.details = _data["Details"] ? PropertyPublicDetails.fromJS(_data["Details"]) : <any>undefined;
            this.expirationDate = _data["ExpirationDate"] ? moment(_data["ExpirationDate"].toString()) : <any>undefined;
            this.startBookingModel = _data["StartBookingModel"] ? StartBookingModel.fromJS(_data["StartBookingModel"]) : <any>undefined;
            this.reservationCode = _data["ReservationCode"];
        }
    }

    static fromJS(data: any): BookingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BookingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        data["Details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["ExpirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["StartBookingModel"] = this.startBookingModel ? this.startBookingModel.toJSON() : <any>undefined;
        data["ReservationCode"] = this.reservationCode;
        return data;
    }

    clone(): BookingInfo {
        const json = this.toJSON();
        let result = new BookingInfo();
        result.init(json);
        return result;
    }
}

export interface IBookingInfo {
    rates?: BookRatesDetails | undefined;
    details?: PropertyPublicDetails | undefined;
    expirationDate?: moment.Moment;
    startBookingModel?: StartBookingModel | undefined;
    reservationCode?: string | undefined;
}

export class BookRatesDetails implements IBookRatesDetails {
    dayRates?: BookRateDayDetails[] | undefined;
    fees?: Charges[] | undefined;
    discounts?: Charges[] | undefined;
    taxes?: Charges[] | undefined;
    promoCodeId?: number | undefined;
    totalDayRent?: number;
    totalDiscounts?: number;
    totalFees?: number;
    totalTaxes?: number;
    total?: number;

    constructor(data?: IBookRatesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DayRates"])) {
                this.dayRates = [] as any;
                for (let item of _data["DayRates"])
                    this.dayRates!.push(BookRateDayDetails.fromJS(item));
            }
            if (Array.isArray(_data["Fees"])) {
                this.fees = [] as any;
                for (let item of _data["Fees"])
                    this.fees!.push(Charges.fromJS(item));
            }
            if (Array.isArray(_data["Discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["Discounts"])
                    this.discounts!.push(Charges.fromJS(item));
            }
            if (Array.isArray(_data["Taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["Taxes"])
                    this.taxes!.push(Charges.fromJS(item));
            }
            this.promoCodeId = _data["PromoCodeId"];
            this.totalDayRent = _data["TotalDayRent"];
            this.totalDiscounts = _data["TotalDiscounts"];
            this.totalFees = _data["TotalFees"];
            this.totalTaxes = _data["TotalTaxes"];
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): BookRatesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookRatesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dayRates)) {
            data["DayRates"] = [];
            for (let item of this.dayRates)
                data["DayRates"].push(item.toJSON());
        }
        if (Array.isArray(this.fees)) {
            data["Fees"] = [];
            for (let item of this.fees)
                data["Fees"].push(item.toJSON());
        }
        if (Array.isArray(this.discounts)) {
            data["Discounts"] = [];
            for (let item of this.discounts)
                data["Discounts"].push(item.toJSON());
        }
        if (Array.isArray(this.taxes)) {
            data["Taxes"] = [];
            for (let item of this.taxes)
                data["Taxes"].push(item.toJSON());
        }
        data["PromoCodeId"] = this.promoCodeId;
        data["TotalDayRent"] = this.totalDayRent;
        data["TotalDiscounts"] = this.totalDiscounts;
        data["TotalFees"] = this.totalFees;
        data["TotalTaxes"] = this.totalTaxes;
        data["Total"] = this.total;
        return data;
    }

    clone(): BookRatesDetails {
        const json = this.toJSON();
        let result = new BookRatesDetails();
        result.init(json);
        return result;
    }
}

export interface IBookRatesDetails {
    dayRates?: BookRateDayDetails[] | undefined;
    fees?: Charges[] | undefined;
    discounts?: Charges[] | undefined;
    taxes?: Charges[] | undefined;
    promoCodeId?: number | undefined;
    totalDayRent?: number;
    totalDiscounts?: number;
    totalFees?: number;
    totalTaxes?: number;
    total?: number;
}

export class BookRateDayDetails implements IBookRateDayDetails {
    day?: number;
    rate?: number;

    constructor(data?: IBookRateDayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["Day"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): BookRateDayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookRateDayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Day"] = this.day;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): BookRateDayDetails {
        const json = this.toJSON();
        let result = new BookRateDayDetails();
        result.init(json);
        return result;
    }
}

export interface IBookRateDayDetails {
    day?: number;
    rate?: number;
}

export class Charges implements ICharges {
    name?: string | undefined;
    rate?: number;

    constructor(data?: ICharges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): Charges {
        data = typeof data === 'object' ? data : {};
        let result = new Charges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): Charges {
        const json = this.toJSON();
        let result = new Charges();
        result.init(json);
        return result;
    }
}

export interface ICharges {
    name?: string | undefined;
    rate?: number;
}

export class ReservationAccountShortInfo implements IReservationAccountShortInfo {
    reservationCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    status?: PropertyReservationStatus;

    constructor(data?: IReservationAccountShortInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationCode = _data["ReservationCode"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.country = _data["Country"];
            this.thumbnailImageUrl = _data["ThumbnailImageUrl"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.total = _data["Total"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ReservationAccountShortInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAccountShortInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReservationCode"] = this.reservationCode;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Country"] = this.country;
        data["ThumbnailImageUrl"] = this.thumbnailImageUrl;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Total"] = this.total;
        data["Status"] = this.status;
        return data;
    }

    clone(): ReservationAccountShortInfo {
        const json = this.toJSON();
        let result = new ReservationAccountShortInfo();
        result.init(json);
        return result;
    }
}

export interface IReservationAccountShortInfo {
    reservationCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    status?: PropertyReservationStatus;
}

/** 1 = Requested 2 = Confirmed 3 = Cancelled */
export enum PropertyReservationStatus {
    Requested = 1,
    Confirmed = 2,
    Cancelled = 3,
}

export class ReservationAccountModel implements IReservationAccountModel {
    reservationCode?: string | undefined;
    rates?: BookRatesDetails | undefined;
    publicDetails?: PropertyPublicDetails | undefined;
    propertyContactDetails?: ReservationAccountContactModel | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    status?: PropertyReservationStatus;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;
    receiptUrl?: string | undefined;
    paymentCreatedAt?: moment.Moment | undefined;

    constructor(data?: IReservationAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationCode = _data["ReservationCode"];
            this.rates = _data["Rates"] ? BookRatesDetails.fromJS(_data["Rates"]) : <any>undefined;
            this.publicDetails = _data["PublicDetails"] ? PropertyPublicDetails.fromJS(_data["PublicDetails"]) : <any>undefined;
            this.propertyContactDetails = _data["PropertyContactDetails"] ? ReservationAccountContactModel.fromJS(_data["PropertyContactDetails"]) : <any>undefined;
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.paymentStatus = _data["PaymentStatus"];
            this.receiptUrl = _data["ReceiptUrl"];
            this.paymentCreatedAt = _data["PaymentCreatedAt"] ? moment(_data["PaymentCreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReservationCode"] = this.reservationCode;
        data["Rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        data["PublicDetails"] = this.publicDetails ? this.publicDetails.toJSON() : <any>undefined;
        data["PropertyContactDetails"] = this.propertyContactDetails ? this.propertyContactDetails.toJSON() : <any>undefined;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["PaymentStatus"] = this.paymentStatus;
        data["ReceiptUrl"] = this.receiptUrl;
        data["PaymentCreatedAt"] = this.paymentCreatedAt ? this.paymentCreatedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReservationAccountModel {
        const json = this.toJSON();
        let result = new ReservationAccountModel();
        result.init(json);
        return result;
    }
}

export interface IReservationAccountModel {
    reservationCode?: string | undefined;
    rates?: BookRatesDetails | undefined;
    publicDetails?: PropertyPublicDetails | undefined;
    propertyContactDetails?: ReservationAccountContactModel | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    status?: PropertyReservationStatus;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;
    receiptUrl?: string | undefined;
    paymentCreatedAt?: moment.Moment | undefined;
}

export class ReservationAccountContactModel implements IReservationAccountContactModel {
    phoneNumber?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;

    constructor(data?: IReservationAccountContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["PhoneNumber"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.address = _data["Address"];
        }
    }

    static fromJS(data: any): ReservationAccountContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAccountContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneNumber"] = this.phoneNumber;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Address"] = this.address;
        return data;
    }

    clone(): ReservationAccountContactModel {
        const json = this.toJSON();
        let result = new ReservationAccountContactModel();
        result.init(json);
        return result;
    }
}

export interface IReservationAccountContactModel {
    phoneNumber?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
}

/** 1 = Failed 2 = Pending 3 = Success */
export enum GetReservationCompletionInfoModelStatus {
    Failed = 1,
    Pending = 2,
    Success = 3,
}

export class SearchCitiesResult implements ISearchCitiesResult {
    city?: string | undefined;
    state?: string | undefined;

    constructor(data?: ISearchCitiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["City"];
            this.state = _data["State"];
        }
    }

    static fromJS(data: any): SearchCitiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCitiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["City"] = this.city;
        data["State"] = this.state;
        return data;
    }

    clone(): SearchCitiesResult {
        const json = this.toJSON();
        let result = new SearchCitiesResult();
        result.init(json);
        return result;
    }
}

export interface ISearchCitiesResult {
    city?: string | undefined;
    state?: string | undefined;
}

export class DataListResultOfPropertySearchListModel implements IDataListResultOfPropertySearchListModel {
    items?: PropertySearchListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertySearchListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertySearchListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertySearchListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertySearchListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertySearchListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertySearchListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertySearchListModel {
    items?: PropertySearchListModel[] | undefined;
    count?: number;
}

export class PropertySearchListModel implements IPropertySearchListModel {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    bedrooms?: number;
    bathroom?: number;
    sleeps?: number;
    longitude?: number;
    latitude?: number;
    rate?: number;
    thumbnailUrl?: string | undefined;

    constructor(data?: IPropertySearchListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.bedrooms = _data["Bedrooms"];
            this.bathroom = _data["Bathroom"];
            this.sleeps = _data["Sleeps"];
            this.longitude = _data["Longitude"];
            this.latitude = _data["Latitude"];
            this.rate = _data["Rate"];
            this.thumbnailUrl = _data["ThumbnailUrl"];
        }
    }

    static fromJS(data: any): PropertySearchListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySearchListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Bedrooms"] = this.bedrooms;
        data["Bathroom"] = this.bathroom;
        data["Sleeps"] = this.sleeps;
        data["Longitude"] = this.longitude;
        data["Latitude"] = this.latitude;
        data["Rate"] = this.rate;
        data["ThumbnailUrl"] = this.thumbnailUrl;
        return data;
    }

    clone(): PropertySearchListModel {
        const json = this.toJSON();
        let result = new PropertySearchListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertySearchListModel {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    bedrooms?: number;
    bathroom?: number;
    sleeps?: number;
    longitude?: number;
    latitude?: number;
    rate?: number;
    thumbnailUrl?: string | undefined;
}

export class DataListGetParamsOfPropertySearchParams implements IDataListGetParamsOfPropertySearchParams {
    filter?: PropertySearchParams | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertySearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertySearchParams.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertySearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertySearchParams {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertySearchParams();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertySearchParams {
    filter?: PropertySearchParams | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertySearchParams implements IPropertySearchParams {
    minBedrooms?: number | undefined;
    maxBedrooms?: number | undefined;
    minBathrooms?: number | undefined;
    maxBathrooms?: number | undefined;
    minRate?: number | undefined;
    maxRate?: number | undefined;
    propertyTypes?: number[] | undefined;
    propertyAmenities?: number[] | undefined;
    guestsAdults?: number | undefined;
    guestsChildren?: number | undefined;
    guestsPets?: number | undefined;
    city?: string | undefined;
    state?: string | undefined;
    from?: number | undefined;
    to?: number | undefined;

    constructor(data?: IPropertySearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minBedrooms = _data["MinBedrooms"];
            this.maxBedrooms = _data["MaxBedrooms"];
            this.minBathrooms = _data["MinBathrooms"];
            this.maxBathrooms = _data["MaxBathrooms"];
            this.minRate = _data["MinRate"];
            this.maxRate = _data["MaxRate"];
            if (Array.isArray(_data["PropertyTypes"])) {
                this.propertyTypes = [] as any;
                for (let item of _data["PropertyTypes"])
                    this.propertyTypes!.push(item);
            }
            if (Array.isArray(_data["PropertyAmenities"])) {
                this.propertyAmenities = [] as any;
                for (let item of _data["PropertyAmenities"])
                    this.propertyAmenities!.push(item);
            }
            this.guestsAdults = _data["GuestsAdults"];
            this.guestsChildren = _data["GuestsChildren"];
            this.guestsPets = _data["GuestsPets"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.from = _data["From"];
            this.to = _data["To"];
        }
    }

    static fromJS(data: any): PropertySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MinBedrooms"] = this.minBedrooms;
        data["MaxBedrooms"] = this.maxBedrooms;
        data["MinBathrooms"] = this.minBathrooms;
        data["MaxBathrooms"] = this.maxBathrooms;
        data["MinRate"] = this.minRate;
        data["MaxRate"] = this.maxRate;
        if (Array.isArray(this.propertyTypes)) {
            data["PropertyTypes"] = [];
            for (let item of this.propertyTypes)
                data["PropertyTypes"].push(item);
        }
        if (Array.isArray(this.propertyAmenities)) {
            data["PropertyAmenities"] = [];
            for (let item of this.propertyAmenities)
                data["PropertyAmenities"].push(item);
        }
        data["GuestsAdults"] = this.guestsAdults;
        data["GuestsChildren"] = this.guestsChildren;
        data["GuestsPets"] = this.guestsPets;
        data["City"] = this.city;
        data["State"] = this.state;
        data["From"] = this.from;
        data["To"] = this.to;
        return data;
    }

    clone(): PropertySearchParams {
        const json = this.toJSON();
        let result = new PropertySearchParams();
        result.init(json);
        return result;
    }
}

export interface IPropertySearchParams {
    minBedrooms?: number | undefined;
    maxBedrooms?: number | undefined;
    minBathrooms?: number | undefined;
    maxBathrooms?: number | undefined;
    minRate?: number | undefined;
    maxRate?: number | undefined;
    propertyTypes?: number[] | undefined;
    propertyAmenities?: number[] | undefined;
    guestsAdults?: number | undefined;
    guestsChildren?: number | undefined;
    guestsPets?: number | undefined;
    city?: string | undefined;
    state?: string | undefined;
    from?: number | undefined;
    to?: number | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}